import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import UnleashYourInnerBeast from "./sections/UnleashYourInnerBeast";
import TechnicalAdvantages from "./sections/TechnicalAdvantages";
import OurPlayPhilosophy from "./sections/OurPlayPhilosophy";
import OurExpertise from "./sections/OurExpertise";
import ClientSuccessStories from "./sections/ClientSuccessStories";
import JoinTheFoundersCircle from "./sections/JoinTheFoundersCircle";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <UnleashYourInnerBeast />
      <TechnicalAdvantages />
      <OurPlayPhilosophy />
      <OurExpertise />
      <ClientSuccessStories />
      <JoinTheFoundersCircle />
      <Footer />
    </div>;
}